import * as yup from 'yup';
export const userProfileSchema = yup.object().shape({
    first_name: yup.string().required(),
    last_name: yup.string().required(),
    /** E.164 phone number for click to call. Empty string clears it */
    phone_number: yup.string().optional(),
});
//# sourceMappingURL=userProfile.js.map